import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { AlertService } from '../../views/shared/alert/alert.service';

/**
 * On 401 Unauthorized: show "Session expired", redirect to login, no error to caller.
 */
export const auth401Interceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const alertService = inject(AlertService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('appUserID');
        localStorage.setItem('userDetails', '');
        alertService.warning('Session expired');
        router.navigate(['/login'], { queryParamsHandling: 'preserve' });
        return EMPTY;
      }
      throw err;
    })
  );
};
